export default {
  roosterForecast: {},
};
